import { Slider, styled } from '@mui/material';
import { TrackGrid } from '../TrackGrid';

export const StyledTrackGrid = styled(TrackGrid)(({ theme }) => ({
  borderTopWidth: 1,
  borderTopStyle: 'solid',
  borderTopColor: theme.palette.grey[900],
}));

export const StyledSlider = styled(Slider)(() => ({
  height: '1px',
  display: 'flex',
  '& .MuiSlider-thumb': {
    display: 'none',
  },
  '& .MuiSlider-track': {
    height: '1px',
    transition: 'none',
  },
  maxWidth: 280,
}));
